// Auto-generated by js:build_react
import { installReactComponents } from "./react_loader"

installReactComponents({
  'react-bootstrap-components': () => import('./components/BootstrapComponents.jsx'),
  'react-bootstrap-dialog': () => import('./components/BootstrapDialog.jsx'),
  'react-detail-field': () => import('./components/DetailField.jsx'),
  'react-generic-modal': () => import('./components/GenericModal.jsx'),
  'react-paginator': () => import('./components/Paginator.jsx'),
  'react-shortcut-hint': () => import('./components/ShortcutHint.jsx'),
  'react-documents-template-editor': () => import('../../engines/documents/app/javascript/components/TemplateEditor.jsx'),
  'react-procurement-buy-list': () => import('../../engines/procurement/app/javascript/components/BuyList.jsx'),
  'react-procurement-goods-receipt': () => import('../../engines/procurement/app/javascript/components/GoodsReceipt.jsx'),
  'react-procurement-purchase-order': () => import('../../engines/procurement/app/javascript/components/PurchaseOrder.jsx'),
})